import { z } from "zod";
import { TinType } from "../types/counterparty";
import {
    CounterpartyTinDenialReason,
    CounterpartyTinGrantAction,
} from "../types/counterpartyTin";

export const counterpartyTinPathParamsSchema = z.object({
    workspaceId: z.string().uuid(),
    counterpartyId: z.string().uuid(),
});

export const counterpartyTinReviewSchema = z.object({
    id: z.string().uuid(),
    userId: z.number(),
    reviewedRevisionId: z.string().uuid(),
    createdAt: z.coerce.date(),
});
export type CounterpartyTinReview = z.infer<typeof counterpartyTinReviewSchema>;

/** `reviews` holds the admin reviews of the current `tinRevisionId` only. */
export const counterpartyTinStatusResponseSchema = z.object({
    tinType: z.nativeEnum(TinType).nullable(),
    tinRevisionId: z.string().uuid().nullable(),
    reviews: z.array(counterpartyTinReviewSchema),
});

export const createCounterpartyTinGrantBodySchema = z
    .object({
        action: z.nativeEnum(CounterpartyTinGrantAction),
    })
    .strict();

export const counterpartyTinExportGrantPathParamsSchema = z.object({
    workspaceId: z.string().uuid(),
});

export const createCounterpartyTinExportGrantBodySchema = z
    .object({
        taxYear: z.number().int().min(2000).max(2100),
        entityId: z.number().int().positive(),
    })
    .strict();

export const exportCounterpartyTinBodySchema = z
    .object({
        grant: z.string().min(1),
    })
    .strict();

export const createCounterpartyTinGrantResponseSchema = z.object({
    grant: z.string(),
    expiresAt: z.string().datetime({ offset: true }),
});

export const counterpartyTinErrorSchema = z.object({
    message: z.string(),
    code: z
        .enum([
            CounterpartyTinDenialReason.STEP_UP_REQUIRED,
            CounterpartyTinDenialReason.TIN_NOT_SET,
            CounterpartyTinDenialReason.TIN_CHANGED,
            CounterpartyTinDenialReason.RATE_LIMITED,
        ])
        .optional(),
});

export const reviewCounterpartyTinBodySchema = z
    .object({
        tinRevisionId: z.string().uuid(),
    })
    .strict();

export const reviewCounterpartyTinResponseSchema = z.object({
    review: counterpartyTinReviewSchema,
});

export const revokeCounterpartyTinReviewResponseSchema = z.object({
    deleted: z.boolean(),
});

export const writeCounterpartyTinBodySchema = z
    .object({
        tin: z.string(),
        tinType: z.nativeEnum(TinType),
    })
    .strict();

export const writeCounterpartyTinResponseSchema = z.object({
    tinType: z.nativeEnum(TinType),
});

export const revealCounterpartyTinResponseSchema = z.object({
    token: z.string(),
});

export const counterpartyTinProxiedErrorSchema = z.object({
    message: z.string(),
});
